import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { EventTargetInterruptSource, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { SessiontempComponent } from '../../sessiontemp/sessiontemp.component';
import { JwtService, User, UserService } from '../../shared';
import { SucesstempComponent } from '../assessmentsucess/sucesstemp.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'dashboard.component.html',
  styleUrls: ['./style.component.css']


})

export class DashboardComponent implements OnInit {
  success: MatDialogRef<SucesstempComponent>
  public dosMaxDate = new Date();
  public OtherSos: any = ""
  public OtherReason: any = ""
  public visitType: any = ''
  public soss: any = ''
  public reason: any = ''
  public dos: any = ''
  params: any;
  public data: Object;
  modalRef: BsModalRef;
  modalRef3: BsModalRef;
  resp: any;
  care: any;
  count: number = 0;
  swf: any;
  surveyform: any;
  temp_var: any;

  type = 'bulletinboard';
  bulletinboard: any;
  apiurl: any = environment.api_url;
  public idletime: any = environment.idletime;
  public setidletime: any = environment.timeset;
  public dateformat = environment.dateFormat;
  public timealert = environment.timelimit;
  public dateform = environment.dateForm;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  carepath: any;
  documenturl: string = environment.documenturl;
  @ViewChild('videoPlayer') videoplayer: any;
  requiredcount: number = 0;
  suggestedcount: number = 0;
  excludeBundle: boolean;
  bulletcount: number = 0;
  CurrentUser: User;
  bullet: any;
  surgeoninfo: any = [];
  patientstatus: any = [];
  imagecount: number = 0;
  profilecount: number = 0;
  supportcount: number = 0;
  allcount: any;
  countt: number = 0;
  episode: boolean = false;
  epi: any;
  newuser: any;
  siteservice: boolean = false;
  reasonstatus: boolean = false;
  showinvaild: boolean = false;
  format: boolean = false;
  allhosp: any = [];
  readmin: any;
  homearr: any = [];
  proSurvey: any = [];
  public imageURL: string = environment.cloudeImageURL;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private userService: UserService,
    private jwtService: JwtService,
    private dialog: MatDialog,
    private element: ElementRef,
    private idle: Idle,
    private keepalive: Keepalive,
    private DatePipe: DatePipe,
    private toast: ToastrService,
    private translate: TranslateService
  ) {
    if (window.localStorage["onboradingCP"]) {
      window.localStorage["onboradingCP"] = false;
    }
    this.translate.setDefaultLang(userService.defaultLang);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.params = params['patswfid']
      // ////console.log("data",this.params)
    });
    if (this.params) {
      this.params = window.localStorage['Puser']
      // ////console.log("puser", window.localStorage['Puser'],this.params)
    }
    ////console.log(this.imagecount,this.profilecount,this.supportcount)
    //this.jwtService.getworkflow()  
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        this.CurrentUser.status = false
        if (this.CurrentUser.item) {
          if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
        }////console.log(this.CurrentUser, "CurrentUser");
      }
    )
    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    if (this.route.snapshot.url[0].path != 'assessment') {
      this.CurrentUser.operationStatus = ''
    }
    this.userService.PUser.subscribe(
      (user) => {
        this.resp = user;
        this.epi = this.resp;
        if (this.resp.patientId) {
          this.userService.getPatientDetails(this.resp.patientId).subscribe(
            data => {
              let self = this
              self.patientstatus = data
              if (self.patientstatus) {
                if (self.patientstatus.isImageUploadDone == false && !self.getStageCheck()) {
                  self.imagecount = 1
                }
                if (self.patientstatus.isProfileDone == false && !self.getStageCheck()) {
                  self.profilecount = 1
                }
                if (self.patientstatus.isSupportDone == false) {
                  self.supportcount = 1
                }
              }
              if (self.count == 0) {
                self.count = self.count + self.imagecount + self.profilecount + self.supportcount;
                self.getcarePath()
              }
            }
          )
        }
      }
    )

    // Get Exclude Bundle
    this.userService.getExcludeBundle(window.localStorage['Puser']).subscribe(
      data => {
        let self = this
        self.excludeBundle = data.excludeBundle;
      });
    this.swf = window.localStorage['Puser'];
    this.userService.getbulletindashboard(this.type, window.localStorage['Puser']).subscribe(
      data => {
        this.bulletinboard = data;
        this.bulletcount = this.bulletinboard.length
      }
    );
    this.episodetype()
    this.readmission()
  }

  associatedSurveyDetail: any
  getcarePath() {
    this.userService.getcarepath(window.localStorage['Puser']).subscribe(
      data => {
        let self = this
        self.excludeBundle
        self.proSurvey = []
        self.homearr = []
        self.carepath = data
        self.count = self.imagecount + self.profilecount + self.supportcount
        self.associatedSurveyDetail = self.userService.checkForAssociateSurveyInPatientDashboard(self.carepath)
        for (var k = 0; k < data.length; k++) {
          if (data[k].priorityId) {
            ++self.requiredcount;
            ++self.count
          }
          else {
            ++self.suggestedcount;
            ++self.count
          }

        }

        if (self.carepath.length >= 1) {
          self.temp_var = 1;

        }
        else {
          self.temp_var = 0;

        }

        var theAssociateSurveyId = 0
        var index = undefined
        var count = 0


        var importantpreop = null;
        if (!this.isRateYourKneeFunction(self.carepath))
          importantpreop = this.getAndDeleteImportantpreOfQuestion(self.carepath);


        for (var i = self.carepath.length - 1; i >= 0; i--) {
          if ((self.carepath[i].designproductId == 262) || (self.carepath[i].designproductId == 261) || (self.carepath[i].designproductId == 339)) {
            self.homearr.push(self.carepath[i]);
            self.carepath.splice(i, 1)
          }
          else if ((self.carepath[i].todoCategoryId == '19') || (self.carepath[i].todoCategoryId == '20')) {
            if (self.carepath[i].associateHsmId != "" && self.carepath[i].associateHsmId != null && self.carepath[i].associateHsmId != 0) {
              count += 1
              theAssociateSurveyId = self.carepath[i].associateHsmId
              self.proSurvey.push(self.carepath[i]);
              index = self.proSurvey.indexOf(self.carepath[i])
              self.carepath.splice(i, 1)
            }

            else {
              self.proSurvey.push(self.carepath[i]);
              self.carepath.splice(i, 1)
            }
          }
          else if (self.associatedSurveyDetail.includes(self.carepath[i].name.toLowerCase())) {
            if (count <= 1)
              self.proSurvey.splice(index != undefined && index != null ? index : self.proSurvey.length, 0, self.carepath[i]);
            else
              self.proSurvey.splice(index != undefined && index != null ? index - 1 : self.proSurvey.length, 0, self.carepath[i]);

            self.carepath.splice(i, 1)
          }
          else if (theAssociateSurveyId != 0 && self.carepath[i].hpsmId == theAssociateSurveyId) {
            if (count <= 1)
              self.proSurvey.splice(index != undefined && index != null ? index : self.proSurvey.length, 0, self.carepath[i]);
            else
              self.proSurvey.splice(index != undefined && index != null ? index - 1 : self.proSurvey.length, 0, self.carepath[i]);
            self.carepath.splice(i, 1)
          }

        }

        self.homearr.reverse()
        if (importantpreop != null)
          self.homearr.push(importantpreop);

        self.proSurvey.reverse()
      }
    );
  }

  isRateYourKneeFunction(carePathObj: any) {
    var temp19thCard = [];
    for (var i = carePathObj.length - 1; i >= 0; i--) {
      if (carePathObj[i].todoCategoryId == '19')
        temp19thCard.push(carePathObj[i].name)
    }

    if (temp19thCard.length == 1) {
      if (temp19thCard[0] == "Pain Survey")
        return false
      else
        return true

    } else if (temp19thCard.length > 1)
      return true

    return false;
  }


  getAndDeleteImportantpreOfQuestion(carePathObj: any) {
    for (var i = carePathObj.length - 1; i >= 0; i--) {
      if (carePathObj[i].name == 'Important Pre-Op Questions') {
        var obj = JSON.parse(JSON.stringify(carePathObj[i]));

        carePathObj.splice(i, 1);

        return obj;
      }

    }
    return null;
  }


  idleState = 'NOT_STARTED';
  timedOut = false;
  lastPing?: Date = null;
  progressBarPopup: MatDialogRef<SessiontempComponent>;
  session() {

    this.resetTimeOut();
    //alert("Session Calling");
    // sets an idle timeout of 15 minutes.
    this.idle.setIdle(this.idletime);
    // sets a timeout period of 5 minutes.

    // alert("1");
    this.idle.setTimeout(this.setidletime);
    // sets the interrupts like Keydown, scroll, mouse wheel, mouse down, and etc
    this.idle.setInterrupts([
      new EventTargetInterruptSource(
        this.element.nativeElement, 'keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll')]);

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'NO_LONGER_IDLE';

    });
    // alert("2");

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'NO_LONGER_IDLE';

    });

    //alert("3");

    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'TIMED_OUT';
      this.timedOut = true;
      //this.closeProgressForm();
      this.progressBarPopup.close();
      window.localStorage['session'] = true;
      this.logout();
    });

    // alert("4");
    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'IDLE_START';
      this.openProgressForm(1);
    });

    // alert("5");

    this.idle.onTimeoutWarning.subscribe((countdown: any) => {

      this.sessionForm(countdown);
    });

    //  alert("6");
    this.keepalive.interval(15);

    //  alert("7");
    this.idle.watch();


    //alert("Bottom");

  }
  public openProgressForm(count: number) {

    this.progressBarPopup = this.dialog.open(SessiontempComponent, { hasBackdrop: true, disableClose: true });
    this.progressBarPopup.componentInstance.count = count;

    this.progressBarPopup.afterClosed().subscribe(result => {


      this.progressBarPopup.close();

      //  alert(result);

      if (result == 'logout' || result == undefined) {

        this.logout();

      } else {

        this.resetTimeOut();
        this.session();
      }


    });
  }




  logout() {
    this.resetTimeOut();
    this.userService.logoutuser(this.CurrentUser.item.userAccountId)
    this.progressBarPopup.close();
    this.userService.purgeAuth();
  }

  closeProgressForm() {
    this.progressBarPopup.close();
    //this.resetTimeOut()
  }

  resetTimeOut() {
    try {
      this.idle.stop();
      this.idle.ngOnDestroy();
      this.idle.onTimeout.observers.length = 0;
      this.idle.onIdleStart.observers.length = 0;
      this.idle.onIdleEnd.observers.length = 0;
      this.idle.onTimeoutWarning.observers.length = 0;
    } catch (Exception) {

    }
    /* this.idle.onIdleStart.unsubscribe();
    this.idle.onTimeoutWarning.unsubscribe();
    this.idle.onIdleEnd.unsubscribe();
    this.idle.onTimeoutWarning.unsubscribe(); */

  }

  public sessionForm(countdown: any): any {
    this.idleState = 'IDLE_TIME_IN_PROGRESS';
    this.progressBarPopup.componentInstance.count = (Math.floor((countdown - 1) / 60) + 1);
    this.progressBarPopup.componentInstance.progressCount = this.reverseNumber(countdown);
    this.progressBarPopup.componentInstance.countMinutes = (Math.floor(countdown / 60));
    this.progressBarPopup.componentInstance.countSeconds = countdown % 60;
  }

  reverseNumber(countdown: number) {
    return (300 - (countdown - 1));
  }


  video(template12: TemplateRef<any>, video) {

    this.modalRef = this.modalService.show(template12, { backdrop: 'static' });
    this.care = video;
    this.movable()
  }
  bulletvideo(template123: TemplateRef<any>, video) {

    this.modalRef = this.modalService.show(template123, { backdrop: 'static' });
    this.bullet = video;
    this.movable()
  }
  openreadmision(news: TemplateRef<any>) {

    this.modalRef = this.modalService.show(news, { backdrop: 'static' });
    this.movable()
  }
  pauseOrPlay(video) {
    video.pause();
    video.currentTime = 0;
    this.modalRef.hide();
    this.userService.updatesurvey(this.care.patientVideoMappingId, this.care.type)
      .subscribe(
        data => {
          this.surveyform = data;
          //////console.log(data);
          if (data.updateStatus == "true") {
            this.userService.logAudit("updatereviewstatus", 0).subscribe(data => { })
            this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
            this.success.componentInstance.assessment = 'activity';
            this.success.componentInstance.message = 'completed';
            this.success.componentInstance.fullMessage = this.userService.translateText('patient_portal.assessment.submit_success.message')
            if (window.localStorage['Puser']) {
              this.userService.getusersession()
                /* this.userService.getusersessionMulti(this.CurrentUser.item.userAccountId) */
                .subscribe(
                  data => {
                    if (data)
                      this.userService.setUser(data[0].patientStageWorkflow[0]);
                    //  ////console.log(data , "Patient")
                  },
                  err => this.userService.purgeAuth()
                );
            }
            this.getcarePath()
          }
          else {

          }
        });
  }
  episodetype() {

    this.userService.getusersession()
      /* this.userService.getusersessionMulti(this.CurrentUser.item.userAccountId) */
      .subscribe(
        data => {

          this.newuser = data;

          ////console.log(this.newuser[0].patientStageWorkflow[0].episode)

          var epid = this.newuser[0].patientStageWorkflow[0].episode.filter(item => item.episodeId == this.newuser[0].patientStageWorkflow[0].currentEpisodeId)
          ////console.log(epid)
          if (epid[0].episodeName == this.userService.translateText('patient_portal.assessment.follow_up.check') || epid[0].episodeName == this.userService.translateText('patient_portal.activity_board.follow_up.label') || epid[0].episodeName == this.userService.translateText('patient_portal.assessment.recovery.check')) {
            this.episode = true
          }
          else {
            this.episode = false
          }
        });
  }



  readmissionDateRestriction: any = {
    mindate: null,
    maxdate: null
  }

  readmission() {
    this.userService.getReadmission(window.localStorage['Puser']).subscribe(
      data => {
        if (data) {
          this.readmin = data
          this.readmissionDateRestriction.mindate = new Date(this.readmin.dischargeDate);
          this.readmissionDateRestriction.maxdate = new Date();
          if (data.willReAdmissionBeShown.toLowerCase() == "y") {
            this.userService.fetchHospitalListForReadmission(this.readmin.userAccountId).subscribe((res) => {
              this.allhosp = res.aaData;
            })
          }
        }
      }
    )
  }

  navigateToURL(actbody) {
    let assesDetails = {
      'name': actbody.patientSveryMappingId,
      'title': actbody.name,
      'materialId': actbody.ID,
      'patedit': 'new'
    }
    window.localStorage['assesDetails'] = btoa(JSON.stringify(assesDetails))
    this.router.navigateByUrl('/patient/assessment')
  }
  site(event) {
    ////console.log(event)
    this.OtherSos = ''
    if (event == 'Other') {
      this.siteservice = true
    }
    else {
      this.siteservice = false
    }
  }
  checkchange(id) {

    let date
    if (id != 'Invalid Date')
      date = this.DatePipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.DatePipe.transform(new Date(), 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.dos = null;

      this.showinvaild = false;
      this.format = true
    } else if (id != '' && id != null && date > curentdate) {
      this.dos = '';
      this.showinvaild = true;
      this.format = false
    } else {

      this.showinvaild = false;
      this.format = false
    }
  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }

  reasons(event) {
    ////console.log(event)
    this.OtherReason = ''
    if (event == 'Other') {
      this.reasonstatus = true
    }
    else {
      this.reasonstatus = false
    }

  }
  reportadmin(report) {



    ////console.log(report.value)
    if (report.value.OtherSos == undefined) {
      report.value.OtherSos = ""
    }
    if (report.value.OtherReason == undefined) {
      report.value.OtherReason = ""
    }
    if (report.value.reason == 'Other') {
      report.value.reason = "Other"
    }
    if (report.value.soss == 'Other') {
      report.value.soss = ""
    }
    let fulldata = {
      "hospitalId": report.value.soss,
      "otherHospitalName": report.value.OtherSos,
      "raOtherReason": report.value.OtherReason,
      "patientReadmissionId": 0,
      "readmissionDate": "",
      "readmissionDateStr": this.DatePipe.transform(this.changeFormatToDate(report.value.dos), 'yyyy-MM-dd'),
      "raReason": report.value.reason,
      "visitType": report.value.visitType,
      "initiatedBy": this.CurrentUser.item.userAccountId
    }
    ////console.log(fulldata)
    ////console.log(this.params)
    this.isReadmissionDateInSameDate(fulldata);

  }

  isReadmissionAvailable: any;
  isReadmissionDateInSameDate(fulldata) {
    this.userService.cheReadm(window.localStorage['Puser'], fulldata).subscribe(
      (data) => {

        this.isReadmissionAvailable = data;
        if (!this.isReadmissionAvailable.isSameReadmission) {
          this.saveReadmission(fulldata);
        } else {
          this.toast.error(this.userService.translateText('patient_portal.display_messages.readmission_exist.error_label'), '', {
            timeOut: this.timealert
          });
        }
      });
  }
  saveReadmission(fulldata) {
    this.userService.saveRemit(window.localStorage['Puser'], fulldata).subscribe(
      (data) => {
        if (data) {
          this.userService.logAudit("savePatientReadmission", 0).subscribe(data => { })
          this.toast.success(this.userService.translateText('patient_portal.display_messages.saved_successfully'), '', {
            timeOut: this.timealert
          });
        }
        else {
          this.toast.error(this.userService.translateText('patient_portal.display_messages.something_went_wrong'), '', {
            timeOut: this.timealert
          });
        }
        this.soss = "";
        this.reason = "";
        this.dos = "";
        this.visitType = ""
        this.OtherSos = ""
        this.OtherReason = ""
        this.reasonstatus = false;
        this.siteservice = false;
        this.modalRef.hide()
      }
    )
  }


  close() {
    this.modalRef.hide();
    this.soss = "";
    this.reason = "";
    this.dos = "";
    this.reasonstatus = false;
    this.siteservice = false;
    this.showinvaild = false;
    this.format = false;
    this.visitType = "";
    this.OtherReason = "";
    this.OtherSos = ""

  }

  document(care) {
    ////console.log(care)
    //this.userService.documentURL = actbody.filePath;
    let pdfOption = {
      'type': care.fileType ? care.fileType : 'pdf',
      'path': care.filepath,
      'id': care.patientfrommappingid,
      'status': care.reviewStatus,
      'materialId': care.ID,
      'patswfid': this.swf,
      'productID': care.formproductId
    }
    if (pdfOption.type == 'html')
      pdfOption.path = care.htmlPath
    window.localStorage['pdfPath'] = btoa(JSON.stringify(pdfOption));
    this.router.navigateByUrl('/patient/preventinginfection')
    // routerLink="/patient/preventinginfection/{{actbody.materialHspPatientMappingId}}/{{actbody.reviewStatus}}/{{actbody.materialId}}/{{this.swfid}}/{{actbody.productId}}/{{actbody.filePath}}"
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
  changeFormatToDate(dateString) {
    var changedFormat;
    if (this.CurrentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
      var splitDate1 = dateString.split('/');
      if (splitDate1.length > 1) {
        var day1 = splitDate1[0];
        var month1 = splitDate1[1];
        var year1 = splitDate1[2];
        changedFormat = month1 + "/" + day1 + "/" + year1;
        return changedFormat
      } else {
        var date: any = dateString
        return new Date(date)
      }
    } else {
      return new Date(dateString)
    }
  }

  enablevideo: any = true
  iWatched(video) {
    if ((video.duration - video.currentTime) <= 4) {
      this.enablevideo = false
    }
    else {
      this.enablevideo = true
    }
  }

  getStageCheck() {
    let date = new Date()
    let dosdate = new Date(this.resp.dos)
    if (dosdate < date) {
      return true
    } else {
      return false
    }
  }

  bulletinBoard(bullet) {
    sessionStorage.setItem("bulletinboardFilePath", bullet?.filePath);
    this.router.navigate([`/patient/postoperative/${bullet.type}/${bullet.bulletinBoardId}`])
  }
}





